import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const OpenGraphMetadataEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    type: z.enum(['article', 'website']),
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    emails: z.array(z.string()).optional().nullable(),
    phoneNumbers: z.array(z.string()).optional().nullable(),
    siteName: z.string().optional().nullable(),
    imageUrls: z.array(z.string()).optional().nullable(),
    authors: z.array(z.string()).optional().nullable(),
    section: z.string().optional().nullable(),
    tags: z.array(z.string()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export const LocalizedOpenGraphMetadataEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.record(z.string(), z.string()),
    type: z.record(z.string(), z.enum(['article', 'website'])),
    title: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    description: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    emails: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable(),
    phoneNumbers: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable(),
    siteName: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    imageUrls: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable(),
    authors: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable(),
    section: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    tags: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
